interface EnvironmentConfig {
	name: string;
	apiBaseUrl: string;
	supabaseUrl: string;
	supabasePublishableKey: string;
}

const environments: Record<string, EnvironmentConfig> = {
	local: {
		name: "local",
		apiBaseUrl: "http://localhost:3100",
		supabaseUrl: import.meta.env.VITE_SUPABASE_URL ?? "",
		supabasePublishableKey: import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY ?? "",
	},
	dev: {
		name: "dev",
		apiBaseUrl: "https://api-dev-580673897909.europe-west3.run.app",
		supabaseUrl: import.meta.env.VITE_SUPABASE_URL ?? "",
		supabasePublishableKey: import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY ?? "",
	},
	test: {
		name: "test",
		apiBaseUrl: "https://api-dev-580673897909.europe-west3.run.app",
		supabaseUrl: import.meta.env.VITE_SUPABASE_URL ?? "",
		supabasePublishableKey: import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY ?? "",
	},
	production: {
		name: "production",
		apiBaseUrl: "https://api-prod-580673897909.europe-west3.run.app",
		supabaseUrl: import.meta.env.VITE_SUPABASE_URL ?? "",
		supabasePublishableKey: import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY ?? "",
	},
};

function validateEnvironment(): EnvironmentConfig {
	const envName = import.meta.env.VITE_APP_ENV || "local";
	const config = environments[envName];

	if (!config) {
		console.warn(`Unknown environment "${envName}", falling back to "local"`);
		return environments.local;
	}

	if (!config.supabaseUrl || !config.supabasePublishableKey) {
		console.error(
			"Missing VITE_SUPABASE_URL or VITE_SUPABASE_PUBLISHABLE_KEY environment variables",
		);
	}

	return config;
}

export const envConfig = validateEnvironment();
